import { IProduct } from '../types';
import { getAppState } from 'app/store/configureStore';
import { getProducts } from 'app/store/model/authUser/selectors/getProducts';
import { sendErrorEmailWithoutDispatch } from 'app/rest/effects/utils/sendErrorEmail';

export const getProductById = (
    productId: number
): IProduct => {
    const state = getAppState();
    const products = getProducts(state);
    const product = products.find(product => product.id === productId);
    if (!product){
        let message = `Product with ID: ${productId} not found`;
        sendErrorEmailWithoutDispatch(1,message);
        console.error(message)
    }
    return product;
};
